import React from 'react'

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { useAppSelector } from '../../app/store/hooks'
import styles from "./loaderButton.module.css";

type Props = {
    text: string,
    disabled?: boolean,
    loading?: boolean,
    onClick: React.MouseEventHandler<HTMLButtonElement>
}

const LoaderButton = ({ disabled, text, loading, onClick }: Props): JSX.Element => {
    const createSubstepOpen = useAppSelector((state) => state.recipeCreation.createSubstepOpen);

    return (
        <Button className={createSubstepOpen ? styles.create_btn_dialog : styles.create_btn_dialog_inactive} disabled={disabled} onClick={onClick}>
            <Typography variant='caption3Light' >{text}</Typography>
            {loading && <Box className={styles.loader_container}> <CircularProgress color='inherit' disableShrink size={15} /></Box>}
        </Button>
    )
}

LoaderButton.defaultProps = {
    disabled: false,
    loading: false,
}

export default LoaderButton